export default __webpack_public_path__ + "static/media/Group 3217@2x.b0889765.png";